import { Container } from "react-bootstrap";
import PageHeader from "../../components/pageHeader";
import { Button, ConfigProvider, Dropdown, Select, type MenuProps } from "antd";
import { IoIosArrowDropdown } from "react-icons/io";
import "./style.scss";
import DataTable from "./components/dataTable";
import data from "./components/data.json";
import { useEffect, useState } from "react";

const MeasurementScreen = () => {
  const [senderCode,setSenderCode] = useState<number>()
  const [digitaltwinId,setDigitalTwinId] = useState<number>()
  useEffect(()=>{

  },[senderCode,digitaltwinId])
  const items: MenuProps["items"] = [
    {
      key: "1",
      label: (
        <a target="_blank" rel="noopener noreferrer">
          Item 1
        </a>
      ),
    },
    {
      key: "2",
      label: (
        <a target="_blank" rel="noopener noreferrer">
          Item 2
        </a>
      ),
    },
    {
      key: "3",
      label: (
        <a target="_blank" rel="noopener noreferrer">
          Item 3
        </a>
      ),
    },
  ];

  const filterData = (data:any)=>{
    let filteredArray = data
    if(senderCode){
     filteredArray = data.filter((item:any) => item.id === senderCode);
    }
    if(digitaltwinId){
      filteredArray = data.filter((item:any) => item.id === digitaltwinId);
    }
    
    return filteredArray;
  }

  const onChangeDigitaltwinId = (value:any)=>{
    setDigitalTwinId(value)
  }

  const onChangeSenderCode = (value:any)=>{
    setSenderCode(value)
  }

  return (
    <main>
      <Container fluid>
        <PageHeader
          title={` Measurements`}
          breadcum={"Dashboard / Applications / Measurements"}
        >
          <div className="d-flex flex-column">
            <ConfigProvider theme={{ token: { colorBgContainer: "#FFFFFF" } }}>
              <Select
                showSearch
                placeholder="Sender Code"
                optionFilterProp="label"
                className="custom-select-placeholder"
                onChange={onChangeSenderCode}
                // onSearch={onSearch}
                options={[
                  { value: 1, label: <span>No4 DB WB S</span> },
                  { value: 2, label: <span>No5 S WB S</span> },
                ]}
                suffixIcon={
                  <IoIosArrowDropdown
                    style={{
                      color: "#087EA4",
                      width: 18,
                      height: 18,
                      border: 1.3,
                      marginLeft: "10px",
                    }}
                  />
                }
                allowClear
              />
            </ConfigProvider>
          </div>
          <div>
            <ConfigProvider theme={{ token: { colorBgContainer: "#FFFFFF" } }}>
              <Select
                showSearch
                placeholder="Digital Twin ID"
                optionFilterProp="label"
                className="custom-select-placeholder"
                onChange={onChangeDigitaltwinId}
                // onSearch={onSearch}
                options={[
                  { value: 1, label: <span>hoppe-marine/dt/154697</span> },
                  { value: 2, label: <span>hoppe-marine/dt/193260</span> },
                ]}
                suffixIcon={
                  <IoIosArrowDropdown
                    style={{
                      color: "#087EA4",
                      width: 18,
                      height: 18,
                      border: 1.3,
                      marginLeft: "10px",
                    }}
                  />
                }
                allowClear
              />
            </ConfigProvider>
          </div>
        </PageHeader>
        <DataTable
          data={filterData(data)}
          //   loading={loading}
        />
      </Container>
    </main>
  );
};

export default MeasurementScreen;
